import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getEntities } from 'dash-front/selectors';
import PostImage from '../../../campaign/containers/Posts/PostImage.js';
import * as rmd from 'material-ui';
import moment from 'moment-timezone';
import MessageIcon from 'material-ui/svg-icons/communication/message';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import TimeIcon from 'material-ui/svg-icons/device/access-time';
import PersonIcon from 'material-ui/svg-icons/social/person';
import WidgetIcon from 'material-ui/svg-icons/device/widgets';
import { PostLink } from '../../../campaign/containers/Posts/PublishedPost';
import PostActions from '../../../campaign/containers/Posts/PostActions';
import PostStatus from 'dash-front/campaign/containers/Posts/PostStatus';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import { updatePost } from 'dash-front/campaign/actions/posts';
import { ReadableCondition } from 'dash-front/campaign/components/ReadableCondition';
import { addToQuery } from 'dash-front/helpers';

const withPost = connect(
    (state, { id }) => ({
        post: _.get(getEntities(state).posts, id)
    }),
    (dispatch, { postId }) => ({
        updatePost: (postId, updates) => dispatch(updatePost(postId)(updates))
    })
);

const Status = withPost(PostStatus);

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-top: 25px;
    .imageloader,
    .bigpicture,
    video {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    video {
        object-fit: fill;
    }
`;

const Image = styled.div`
    padding-left: 25px;
    padding-right: 25px;
    flex: 1 0 35%;
    max-width: 35%;
    height: 250px;
    display: flex;
    justify-content: center;
    > div:not(.bigpicture) {
        width: 100%;
    }
`;

const Content = styled.div`
    flex: 1 0 65%;
    max-width: 65%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

const Actions = styled.div`
    flex: 0 1 100%;
    justify-content: flex-end;
    display: flex;
    padding: 5px 25px;
    > div {
        width: 260px;
        display: flex;
        flex-direction: row-reverse;
    }
`;

const Header = styled.div`
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-right: 25px;
`;

const Title = styled.div`
    font-size: 24px;
    line-height: 34px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #4a4a4a;
    margin-bottom: 1px;
`;

const Time = styled.div`
    font-size: 14px;
    line-height: 18px;
    color: #9b9b9b;
    margin-right: 5px;
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
`;
const SocialLinks = styled.div`
    button,
    button svg {
        width: 18px !important;
        height: 18px !important;
    }
    button {
        padding: 0 !important;
        margin: 0 0 0 5px !important;
    }
`;

const Detail = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;
    width: 25%;
    .d__icon {
        margin-right: 20px;
        svg {
            width: 36px !important;
            height: 36px !important;
        }
    }
    .d__title {
        text-transform: uppercase;
        font-size: 12px;
        color: #9b9b9b;
        font-weight: 300;
    }
    .d__body {
        font-size: 16px;
        margin-top: 5px;
        color: rgba(0, 0, 0, 0.87);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

const Details = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    padding-right: 25px;
`;

const Condition = styled.div`
    font-size: 12px;
    color: #9b9b9b;
    line-height: 14px;
    display: flex;
    align-items: center;

    div[tabindex] {
        margin-right: 0 !important;
        background: transparent !important;
        svg {
            width: 36px !important;
            height: 36px !important;
        }
        > span {
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #3f51b5 !important;
            line-height: 14px !important;
            padding: 0 !important;
            margin: 0 !important;
        }
    }
`;

const ActionText = styled.span`
    color: rgba(0, 0, 0, 0.3);
    line-height: 36px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
    margin-right: 20px;
    display: inline-block;
`;

const buildPostTitle = post => _.get(post, 'presentation.params.title');

const buildPostTime = post => {
    return moment(post.createdAt).fromNow();
    // if (moment().diff(post.createdAt))
};

const PostDetail = ({ title, body, icon }) => {
    return (
        <Detail>
            <div className="d__icon">{icon}</div>
            <div style={{ minWidth: 0 }}>
                <div className="d__title">{title}</div>
                <div className="d__body">{body}</div>
            </div>
        </Detail>
    );
};

const edit = id => () => {
    addToQuery('edit', id);
};

const Post = ({ id, post, updatePost }) => {
    let isModerated = _.get(post, 'campaign.moderation');
    let postDetails = [
        {
            title: 'Messages:',
            body: _.get(post, 'content.generatedMessages', []).length,
            icon: <MessageIcon color="#d8d8d8" />
        },
        { title: 'Facts:', body: _.get(post, 'facts', []).length, icon: null },
        {
            title: 'Client:',
            body: `${_.get(post, 'presentation.params.client')}/${_.get(post, 'presentation.params.username')}`,
            icon: <PersonIcon color="#d8d8d8" />
        },
        { title: 'Campaign:', body: _.get(post, 'campaign.title'), icon: null },
        {
            title: 'Last update:',
            body: moment(post.updatedAt).fromNow(),
            icon: <TimeIcon color="#d8d8d8" />
        },
        { title: 'Status:', body: <Status id={id} />, icon: null },
        {
            title: 'Widget:',
            body: _.get(post, 'presentation.name'),
            icon: <WidgetIcon color="#d8d8d8" />
        },
        {
            title: 'Theme:',
            body: _.get(post, 'presentation.params.template', '')
                .split('-')
                .slice(2)
                .join('-'),
            icon: null
        }
    ];

    const isFinished = _.get(post, 'status.state') === 'success' && _.get(post, 'status.step') === 'finished';

    return (
        <Wrapper>
            <Image>
                <PostImage post={post} />
            </Image>
            <Content>
                <Header>
                    <Title>{buildPostTitle(post)}</Title>
                    <Flex>
                        <Time>{buildPostTime(post)}</Time>
                        <SocialLinks>
                            {post.publications.map(publicationId => (
                                <PostLink key={publicationId} publicationId={publicationId} />
                            ))}
                        </SocialLinks>
                    </Flex>
                </Header>
                <Details>
                    {postDetails.map(({ title, body, icon }) => (
                        <PostDetail title={title} body={body} icon={icon} key={title} />
                    ))}
                </Details>
                <Condition>
                    <SettingsIcon color="#d8d8d8" style={{ width: 36, height: 36, marginRight: 18 }} />
                    {post.trigger && <ReadableCondition triggerType={post.triggerType} condition={post.trigger} />}
                    {!post.trigger && <span>Manual post</span>}
                </Condition>
            </Content>
            <Actions>
                {!isFinished &&
                    isModerated && (
                        <rmd.FlatButton
                            primary
                            label={'Edit'}
                            style={{ marginTop: 0 }}
                            onTouchTap={edit(id)}
                            icon={<EditIcon />}
                        />
                    )}
                {!isModerated && !isFinished && <ActionText>No moderation required</ActionText>}
                {!isFinished && <PostActions post={post} />}
                {isFinished && <ActionText>Post published</ActionText>}
            </Actions>
        </Wrapper>
    );
};

Post.propTypes = {
    post: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};

export default withPost(Post);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Hub/Post.js
 **/